<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="container-two-cols">
      <div class="container">
        <div class="columns">
          <div class="column is-5">
            <h2 v-html="homeContent.description" class="mt-6"></h2>
            <h3 class="mt-5 mb-5">{{ homeContent.title }}</h3>
            <div class="home-type tabs">
              <ul>
                <li :class="{'is-active' : isCCIActive}"><a @click="switchTabs('3')">Community College Instructor</a></li>
                <li :class="{'is-active' : isSMEActive}"><a @click="switchTabs('2')">Subject Matter Expert</a></li>
                <li :class="{'is-active' : isPAActive}">
                  <a @click="switchTabs('1')">Resource Access</a>
                </li>
              </ul>
            </div>

            <div class="columns" :class="{'is-block' : isFormActive,'is-hidden': !isFormActive}">
              <div class="column is-12">
                <div :class="{'is-block' : isCCIActive,'is-hidden': !isCCIActive}">
                  <span v-html="homeContent.cciContent"></span>
                </div>
                <div :class="{'is-block' : isSMEActive,'is-hidden': !isSMEActive}">
                  <span v-html="homeContent.smeContent"></span>
                </div>
                <div :class="{'is-block' : isPAActive,'is-hidden': !isPAActive}">
                  <span v-html="homeContent.participationContent"></span>
                </div>
                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{labels.emailLabel}}*</label>
                      <div class="control has-icon has-icon-right">
                        <input name="email" v-model="model.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" type="text">
                        <i v-show="errors.has('email') || errored" class="fa fa-warning"></i>
                        <span v-show="errors.has('email')" class="help is-danger">{{errors.first('email')}}</span>
                        <span v-show="errored" class="help is-danger">{{errorMessage}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{labels.firstNameLabel}}*</label>
                      <div class="control has-icon has-icon-right">
                        <input name="firstname" v-model="model.FirstName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('firstname') }" type="text">
                        <i v-show="errors.has('firstname')" class="fa fa-warning"></i>
                        <span v-show="errors.has('firstname')" class="help is-danger">{{errors.first('firstname')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">{{labels.lastNameLabel}}*</label>
                      <div class="control has-icon has-icon-right">
                        <input name="lastname" v-model="model.LastName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('lastname') }" type="text">
                        <i v-show="errors.has('lastname')" class="fa fa-warning"></i>
                        <span v-show="errors.has('lastname')" class="help is-danger">{{errors.first('lastname')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="model.ParticipationId" @change="switchTabs(model.ParticipationId)">
                      <option v-for="option in model.ParticipationList" v-validate="'required'" v-bind:value="option.Value">
                        {{ option.Text }}
                      </option>
                    </select>
                    <i v-show="errors.has('ParticipationId')" class="fa fa-warning"></i>
                    <span class="help is-danger" v-show="errors.has('ParticipationId')">{{errors.first('ParticipationId')}}</span>
                  </div>
                </div>
                <div class="field">
                  <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="{'with-bg':true,'tab1' : isPAActive || model.ParticipationId == '0', 'tab2' : isSMEActive, 'tab3' : isCCIActive }">
      </div>
    </div>

  </form>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {
        model: {
        },
        errorMessage: '',
        errored: false,
        labels: [],
        homeContent: [],
        isPAActive: false,
        isSMEActive: false,
        isCCIActive: false,
        loading: false,
        isFormActive: false
        
      }
    },
    created() {
      this.$http
        .get('/umbraco/surface/HomeSurface/Home')
        .then(response => {
          console.log(response.data);
          this.model = response.data.model;
          this.labels = response.data.labels;
          this.homeContent = response.data.homeContent;
        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/HomeSurface/PostHome',
                this.model
              )
              .then(response => {
                if (response.data.error) {
                  this.loading = false;
                  this.errorMessage = response.data.error;
                  this.errored = true;
                }
                else if (response.data.redirectURL != "") {
                  this.loading = false;
                  this.false = true;
                  window.location.href = response.data.redirectURL;
                }
              })
              .catch(function (error) {
              });
            return;
          }
        

        });
      },
      recaptcha() {
        // (optional) Wait until recaptcha has been loaded.
        this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        const token = this.$recaptcha('login')
        $("#GoogleRecaptchaToken").val(token);
        console.log(token);

        // Do stuff with the received token.

      },
      switchTabs(tab) {

        if (tab === '1') {
          this.isPAActive = true;
          this.model.ParticipationId = 1;
          this.isSMEActive = false;
          this.isCCIActive = false;
        } else if (tab === '2') {
          this.isPAActive = false;
          this.isSMEActive = true;
          this.model.ParticipationId = 2;
          this.isCCIActive = false;
        }
        else if (tab === '3') {
          this.isPAActive = false;
          this.isSMEActive = false;
          this.isCCIActive = true;
          this.model.ParticipationId = 3;
        }
        else {
          this.isPAActive = false;
          this.isSMEActive = false;
          this.isCCIActive = false;
        }

        this.isFormActive = this.isCCIActive || this.isSMEActive || this.isPAActive;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Home.vue